<template>
  <div class="baidu-map-list-template">
    <div class="panel list-panel">
      <ul class="assets">
        <li
          class="asset"
          v-for="item in listData"
          @click="showDetail(item.primarykey)"
        >
          <p class="title">{{ item.title }}</p>
          <div class="tags">
            <span class="tag" v-for="tag in item.tagListArray">{{ tag }}</span>
          </div>
          <div class="info">
            <div class="base-info">
              <p class="base-info-item">成交价：{{ item.transCurrentprice }}</p>
              <p class="base-info-item">单位价：{{ item.transUnitprice }}</p>
              <p class="base-info-item">挂牌价：{{ item.transListingprice }}</p>
            </div>
            <div class="extra-info">
              <!--<p class="price">{{ item.tranSaverageprice }}/m<sup>2</sup></p>-->
              <p class="date">{{ item.transDate }}</p>
            </div>
          </div>
        </li>
      </ul>
      <el-pagination
        class="pagination"
        layout="prev, pager, next"
        :current-page="page"
        :total="total"
        @current-change="changePage"
      ></el-pagination>
    </div>
  </div>
</template>

<script>
import list from "../mixin/list";
import listMixin from "@/mixins/list";

export default {
  mixins: [listMixin, list],
  data() {
    return {
      initCfg: {
        listApi: "map_getEstateList"
      }
    };
  },
  methods: {
    uploadList(list) {
      return list.map(item => {
        let {
          currentprice,
          unitprice,
          listingprice,
          averageprice,
          renovationcondition,
          usetype,
          endtime
        } = item;

        // 成交价
        let transCurrentprice = currentprice ? `￥${currentprice}` : "暂无数据";
        // 单位价
        let transUnitprice = unitprice ? `￥${unitprice}` : "暂无数据";
        // 挂牌价
        let transListingprice = listingprice ? `￥${listingprice}` : "暂无数据";
        // 平均价
        let tranSaverageprice = averageprice ? `￥${averageprice}` : "暂无均价";
        // 时间
        let transDate = endtime ? endtime.split(" ")[0] : "";

        return {
          ...item,
          tagListArray: [usetype, renovationcondition],
          transCurrentprice,
          transUnitprice,
          transListingprice,
          tranSaverageprice,
          transDate
        };
      });
    },

    // 获取详情
    showDetail(id) {
      this.$emit("on-show-detail", { type: "estate", id });
    }
  }
};
</script>

<style lang="scss" scoped>
@import "../style.scss";
</style>
